import {
  CORPORATE_LOAD_BRANCHES_PENDING,
  CORPORATE_LOAD_BRANCHES_FULFILLED,
  CORPORATE_LOAD_BRANCHES_REJECTED,
  CORPORATE_LOAD_NEW_BRANCHES_PENDING,
  CORPORATE_LOAD_NEW_BRANCHES_FULFILLED,
  CORPORATE_LOAD_NEW_BRANCHES_REJECTED,
  CORPORATE_LOAD_BRANCH_BY_ID_PENDING,
  CORPORATE_LOAD_BRANCH_BY_ID_FULFILLED,
  CORPORATE_LOAD_BRANCH_BY_ID_REJECTED,
  CORPORATE_LOAD_BRANCH_CITIES_PENDING,
  CORPORATE_LOAD_BRANCH_CITIES_FULFILLED,
  CORPORATE_LOAD_BRANCH_CITIES_REJECTED,
  CORPORATE_POST_BRANCH_PENDING,
  CORPORATE_POST_BRANCH_FULFILLED,
  CORPORATE_POST_BRANCH_REJECTED,
  CORPORATE_PUT_BRANCH_PENDING,
  CORPORATE_PUT_BRANCH_FULFILLED,
  CORPORATE_PUT_BRANCH_REJECTED,
  CORPORATE_DELETE_BRANCH_PENDING,
  CORPORATE_DELETE_BRANCH_FULFILLED,
  CORPORATE_DELETE_BRANCH_REJECTED,
  CORPORATE_REMOVE_BRANCH_PENDING,
  CORPORATE_REMOVE_BRANCH_FULFILLED,
  CORPORATE_REMOVE_BRANCH_REJECTED,
  CORPORATE_INVITE_BRANCH_PENDING,
  CORPORATE_INVITE_BRANCH_FULFILLED,
  CORPORATE_INVITE_BRANCH_REJECTED,
  CORPORATE_CLEAR_BRANCH_MESSAGES,
  CORPORATE_LOAD_BRANCH_STATE_PROVINCES_PENDING,
  CORPORATE_LOAD_BRANCH_STATE_PROVINCES_FULFILLED,
  CORPORATE_LOAD_BRANCH_STATE_PROVINCES_REJECTED,
} from '../actions/corporate'

import i18n from 'i18next'

export default function corporate(state = {}, action) {
  switch (action.type) {
    case CORPORATE_LOAD_BRANCHES_PENDING:
    case CORPORATE_LOAD_NEW_BRANCHES_PENDING:
    case CORPORATE_LOAD_BRANCH_BY_ID_PENDING:
    case CORPORATE_LOAD_BRANCH_CITIES_PENDING:
    case CORPORATE_POST_BRANCH_PENDING:
    case CORPORATE_PUT_BRANCH_PENDING:
    case CORPORATE_DELETE_BRANCH_PENDING:
    case CORPORATE_REMOVE_BRANCH_PENDING:
    case CORPORATE_INVITE_BRANCH_PENDING:
    case CORPORATE_LOAD_BRANCH_STATE_PROVINCES_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        successMessage: null,
      }

    case CORPORATE_LOAD_BRANCHES_REJECTED:
    case CORPORATE_LOAD_NEW_BRANCHES_REJECTED:
    case CORPORATE_LOAD_BRANCH_BY_ID_REJECTED:
    case CORPORATE_LOAD_BRANCH_CITIES_REJECTED:
    case CORPORATE_POST_BRANCH_REJECTED:
    case CORPORATE_PUT_BRANCH_REJECTED:
    case CORPORATE_DELETE_BRANCH_REJECTED:
    case CORPORATE_REMOVE_BRANCH_REJECTED:
    case CORPORATE_INVITE_BRANCH_REJECTED:
    case CORPORATE_LOAD_BRANCH_STATE_PROVINCES_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }

    case CORPORATE_LOAD_BRANCHES_FULFILLED:
      const existingBranches = state?.branches || []
      const newBranchIds = action.payload.data?.map((item) => item.id)
      const mergedBranches = existingBranches.filter((b) => !newBranchIds.includes(b.id)).concat(action.payload.data)

      return {
        ...state,
        branches: mergedBranches,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }

    case CORPORATE_LOAD_NEW_BRANCHES_FULFILLED:
      return {
        ...state,
        branches: action.payload.data,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }

    case CORPORATE_LOAD_BRANCH_BY_ID_FULFILLED:
      return {
        ...state,
        branchDetail: action.payload,
        isLoading: false,
      }

    case CORPORATE_LOAD_BRANCH_CITIES_FULFILLED:
      return {
        ...state,
        branchCities: action.payload,
        isLoading: false,
      }

    case CORPORATE_LOAD_BRANCH_STATE_PROVINCES_FULFILLED:
      return {
        ...state,
        branchStateProvinces: action.payload,
        isLoading: false,
      }

    case CORPORATE_POST_BRANCH_FULFILLED:
      return {
        ...state,
        branches: [...(state.branches || []), action.payload],
        isLoading: false,
        successMessage: i18n.t('organization_context.success_add_branch'),
      }

    case CORPORATE_PUT_BRANCH_FULFILLED:
      return {
        ...state,
        branches: state.branches?.map((branch) => (branch.id === action.payload.id ? { ...action.payload } : branch)),
        isLoading: false,
        successMessage: i18n.t('organization_context.success_edit_branch'),
      }

    case CORPORATE_DELETE_BRANCH_FULFILLED:
      return {
        ...state,
        branches: state.branches?.filter((branch) => branch.id !== action.meta.branchId),
        isLoading: false,
        successMessage: i18n.t('organization_context.branch_deleted'),
      }
    case CORPORATE_REMOVE_BRANCH_FULFILLED:
      return {
        ...state,
        branches: state.branches?.filter((branch) => branch.id !== action.meta.branchId),
        isLoading: false,
        successMessage: i18n.t('organization_context.branch_removed_from_corporation'),
      }
    case CORPORATE_INVITE_BRANCH_FULFILLED:
      return {
        ...state,
        isLoading: false,
        successMessage: i18n.t('dealer-portal.invitation_success'),
      }

    case CORPORATE_CLEAR_BRANCH_MESSAGES:
      return {
        ...state,
        errorMessage: null,
        successMessage: null,
      }

    default:
      return state
  }
}
